import { useState } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { clearAuth } from "../store/authSlice";
import { useEffect } from "react";

export default function AdminLayout() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const loc = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(false);
  }, [loc.pathname]);

  const onLogout = () => {
    dispatch(clearAuth());
    nav("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-white flex">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar onLogout={onLogout} onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-3 sm:p-6 bg-white overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
